import React, { useCallback, useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";

import InsuredDriverWrapper from "./InsuredDrivers.style";
import female from "../../assets/images/icons/driver-card-female-icon.svg";
import male from "../../assets/images/icons/driver-card-male-icon.svg";
import editI from "../../assets/images/icons/driver-card-edit.svg";
import trashI from "../../assets/images/icons/driver-card-trash.svg";
import * as globalUtils from "../../helpers/utils";
import { Toast } from "primereact/toast";
import propTypes from "prop-types";
import { InputSwitch } from "primereact/inputswitch";
import AddDriver from "../AddDriver/AddDriver";

const InsuredDrivers = (props) => {
  const toast = useRef(null);
  const [openDriverForm, setOpenDriverForm] = useState(false);
  const [editDriver, setEditDriver] = useState(false);
  const [driverForEdit, setDriverForEdit] = useState(null);
  const [driverList, setDriverList] = useState(props.driverList || []);
  const [usage, setUsage] = useState(false);

  const calculateUsagePercentage = useCallback(() => {
    if (usage) {
      setUsage(false);
      return;
    }
    const values = globalUtils.getPercentageValues(100, driverList.length);
    driverList.forEach((ele, i) => {
      ele["driverUsagePercentageCode"] = `${values[i]}`;
      ele["driverUsagePercentageName"] = `${values[i]}`;
    });
  }, [driverList]);

  useEffect(() => {
    calculateUsagePercentage();
  }, [driverList, calculateUsagePercentage]);

  const onDeleteDriver = (driverId) => {
    const myDriversList = props.driverList.filter(
      (ele) => ele.IDNO !== driverId
    );
    setDriverList(myDriversList);
    props.updateDriversListHandler(myDriversList);
  };

  const onEditDriver = (driver) => {
    setDriverForEdit(driver);
    setEditDriver(true);
    setOpenDriverForm(true);
  };

  const onChangeUsagePercentage = (IDNO, usage) => {
    const restUsage = 100 - usage;
    const values = globalUtils.getPercentageValues(
      restUsage,
      driverList.length - 1
    );
    const myDriversList = [...driverList];

    const restDrivers = myDriversList.filter((ele) => ele.IDNO !== IDNO);
    restDrivers.forEach((ele, i) => {
      ele["driverUsagePercentageCode"] = `${values[i]}`;
      ele["driverUsagePercentageName"] = `${values[i]}`;
    });
    const index = myDriversList.findIndex((ele) => ele.IDNO === IDNO);

    myDriversList[index]["driverUsagePercentageCode"] = `${usage}`;
    myDriversList[index]["driverUsagePercentageName"] = `${usage}`;
    setUsage(true);
    setDriverList(myDriversList);
    props.updateDriversListHandler(myDriversList);
  };

  const isMale = (genderCode) => {
    return !genderCode || genderCode === "M" || genderCode === "1";
  };

  const isMainDriver = (driverType) => {
    return driverType === "MD";
  };

  const updateDriverList = (driversList) => {
    setOpenDriverForm(false);
    setEditDriver(false);
    setDriverForEdit(null);
    setDriverList(driversList);
    props.updateDriversListHandler(driversList);
  };

  const cancelUpdateDriver = () => {
    setOpenDriverForm(false);
    setEditDriver(false);
    setDriverForEdit(null);
  };

  return (
    <InsuredDriverWrapper>
      <Toast ref={toast} />

      <div className={"insured-wrapper"}>
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <h2>{props.i18n.t("POLICY.INSURED_DRIVERS")}</h2>
            </div>
            <div className="col-md-9">
              <div className="drivers-list">
                {driverList.map((item, i) => (
                  <div className="item" key={i}>
                    <div className="details justify-content-start align-items-center pt-0">
                      <img
                        src={isMale(item.genderCode) ? male : female}
                        alt=""
                      />
                      <div className="name-details">
                        <p className="header-title">{props.i18n.t("NAME")}</p>
                        <p className="license name">
                          {globalUtils.isArabic(props.i18n.language)
                            ? item.araFirstName[0] +
                              "****** " +
                              item.araLastName[0] +
                              "******"
                            : item.engFirstName[0] +
                              "****** " +
                              item.engLastName[0] +
                              "******"}
                        </p>
                      </div>

                      <div className="btns">
                        {!isMainDriver(item.driverType) && (
                          <>
                            <button
                              type="button"
                              className="btn"
                              onClick={() => onDeleteDriver(item.IDNO)}
                            >
                              <img src={trashI} alt="" />
                            </button>
                            <button type="button" className="btn">
                              <img src={editI} alt="" />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="divider"> </div>
                    <div className="iqama">
                      <p className="header-title">{props.i18n.t("ID_IQAMA")}</p>
                      <p className="license lato">{`${item?.IDNO.substr(
                        -4
                      )}******`}</p>
                    </div>
                    {/* <div className="divider"> </div>
                    <div className="year-birth">
                      <p className="header-title">
                        {props.i18n.t("YEAR_OF_BIRTH")}
                      </p>
                      <p className="license lato">{item?.gregDob?.slice(6)}</p>
                    </div> */}
                    <div className="divider"> </div>
                    <div className="usage">
                      <p className="header-title">
                        {props.i18n.t("DRIVER_PERCENTAGE")}
                      </p>
                      <div className="usage-list">
                        <button
                          onClick={() => {
                            onChangeUsagePercentage(item.IDNO, 25);
                          }}
                          className={
                            "item " +
                            (item?.driverUsagePercentageCode === "25"
                              ? "active"
                              : "")
                          }
                          disabled={driverList.length === 1}
                        >
                          <span className="lato">25%</span>
                        </button>
                        <button
                          onClick={() => {
                            onChangeUsagePercentage(item.IDNO, 50);
                          }}
                          className={
                            "item " +
                            (item?.driverUsagePercentageCode === "50"
                              ? "active"
                              : "")
                          }
                          disabled={driverList.length === 1}
                        >
                          <span className="lato">50%</span>
                        </button>
                        <button
                          onClick={() => {
                            onChangeUsagePercentage(item.IDNO, 75);
                          }}
                          className={
                            "item " +
                            (item?.driverUsagePercentageCode === "75"
                              ? "active"
                              : "")
                          }
                          disabled={
                            driverList.length > 2 || driverList.length === 1
                          }
                        >
                          <span className="lato">75%</span>
                        </button>
                        <button
                          onClick={() => {
                            onChangeUsagePercentage(item.IDNO, 100);
                          }}
                          className={
                            "item " +
                            (item?.driverUsagePercentageCode === "100"
                              ? "active"
                              : "")
                          }
                          disabled={driverList.length > 1}
                        >
                          <span className="lato">100%</span>
                        </button>
                      </div>
                    </div>
                    <div className="actions">
                      {!isMainDriver(item.driverType) && (
                        <>
                          <p className="header-title">
                            {props.i18n.t("ACTIONS")}
                          </p>
                          <div className="btns">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => onDeleteDriver(item.IDNO)}
                            >
                              <img src={trashI} alt="" />
                            </button>
                            <button
                              type="button"
                              className="btn"
                              onClick={() => onEditDriver(item)}
                            >
                              <img src={editI} alt="" />
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {driverList.length < 4 && (
                <React.Fragment>
                  <div className="my-3">
                    <div className="d-flex flex-start align-items-center">
                      <InputSwitch
                        checked={openDriverForm}
                        onChange={(e) => setOpenDriverForm(e.value)}
                      />
                      <span className="mx-2">
                        {props.i18n.t("POLICY.ADD_DRIVER")}
                      </span>
                    </div>
                  </div>
                  {openDriverForm && (
                    <AddDriver
                      driversList={driverList}
                      updateDriverListHandler={updateDriverList}
                      cancelUpdateDriverHandler={cancelUpdateDriver}
                      editMode={editDriver}
                      driverInfo={driverForEdit}
                    />
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </InsuredDriverWrapper>
  );
};

InsuredDrivers.propTypes = propTypes.exact({
  driverList: propTypes.array.isRequired,
  updateDriverList: propTypes.func.isRequired,
}).isRequired;

export default withTranslation()(InsuredDrivers);
